import { useState, useCallback } from 'react';

import { createDefaultVisibility } from '../lib/data-layer.utils';
import type { DataLayerType } from './types';

export function useDataLayer(initialLayer: DataLayerType = 'stock') {
  const [activeLayer, setActiveLayer] = useState<DataLayerType>(initialLayer);
  const [visibility, setVisibility] = useState<Record<DataLayerType, boolean>>(createDefaultVisibility(initialLayer));

  const toggleLayer = useCallback((layer: DataLayerType) => {
    setVisibility((prev) => ({
      ...prev,
      [layer]: !prev[layer]
    }));
  }, []);

  const setLayer = useCallback((layer: DataLayerType) => {
    setActiveLayer(layer);
    setVisibility(createDefaultVisibility(layer));
  }, []);

  return {
    activeLayer,
    visibility,
    setLayer,
    toggleLayer
  };
}
